// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import vscEntity from './entities/vsc.json';
import vscMenu from '../pages/vsc/menu.json';
import vscFullForm from '../pages/vsc/forms/full.json';
import vscContextForm from '../pages/vsc/forms/context.json';
import vscMiniForm from '../pages/vsc/forms/mini.json';
import vscLookupForm from '../pages/vsc/forms/lookup.json';
import vscTableView from '../pages/vsc/views/table.json';
import vscStagesView from '../pages/vsc/views/stages.json';
import vscCardsView from '../pages/vsc/views/cards.json';
import vscInlineView from '../pages/vsc/views/inline.json';
import vscBacklogView from '../pages/vsc/views/backlog.json';
import vscSplitView from '../pages/vsc/views/split.json';
import vscCalendarView from '../pages/vsc/views/calendar.json';
import vscDashboardView from '../pages/vsc/views/dashboard.json';

/** Тип запису «Розширення» зі сторінками пакета: меню, форми та подання з pages/vsc/. */
export const vscDefinition: IRecordTypeDefinition = {
  ...vscEntity,
  views: assembleViewSet({
      table: vscTableView,
      stages: vscStagesView,
      cards: vscCardsView,
      inline: vscInlineView,
      backlog: vscBacklogView,
      split: vscSplitView,
      calendar: vscCalendarView,
      dashboard: vscDashboardView,
  }),
  form: vscFullForm,
  forms: { full: vscFullForm, context: vscContextForm, mini: vscMiniForm, lookup: vscLookupForm },
  menu: vscMenu,
} as IRecordTypeDefinition;
